import styled from "styled-components";
import {ReactNode} from "react";

const IconButtonStyle = styled.div`
  min-width: 40px;
  min-height: 40px;
  height: 35px;
  width: 35px;
  align-self: center;
  border-radius: 50%;
  border: 0.15rem solid ${(props: {color: string}) => props.color};
  color: ${props => props.color};
  cursor: pointer;
`;

const IconButtonContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  transition: .1s;
  &:hover {
    background: rgba(0,0,0,0.05);
  }
`;


export default function IconButton(props: {color: string, children: ReactNode, onClick: () => void}) {
    return <IconButtonStyle color={props.color} onClick={props.onClick}>
        <IconButtonContent>
            {props.children}
        </IconButtonContent>
    </IconButtonStyle>
}
